export default __webpack_public_path__ + "static/julien-5cc17a019c4feb0da0f65dfba61d27af.jpg";